import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Track-once-per-tab. A session-storage key prevents counting the same tab
// multiple times if React StrictMode double-mounts during dev.
const TAB_KEY = "newseze.pv.beacon.fired";

/**
 * PvStatsStrip — two numbers, no labels beyond "PV" and "PVT", no explanation.
 * Renders on the home page after Buildeze per user spec (2026-06-18).
 */
export default function PvStatsStrip() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fired = sessionStorage.getItem(TAB_KEY);
    const fetcher = fired
      ? axios.get(`${API}/stats/pv`, { timeout: 8000 })
      : axios.post(`${API}/stats/pv`, {}, { timeout: 8000 });

    fetcher
      .then((r) => { if (!cancelled) { setStats(r.data); sessionStorage.setItem(TAB_KEY, "1"); } })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const fmt = (n) => (typeof n === "number" ? n.toLocaleString("en-US") : "—");

  return (
    <section className="my-6" data-testid="pv-stats-strip">
      <div className="grid grid-cols-2 gap-3 max-w-2xl mx-auto">
        <div className="rounded-xl border border-[var(--line)] bg-white p-4 text-center" data-testid="pv-stat-total">
          <div className="text-[11px] uppercase tracking-[0.22em] font-black text-[var(--muted)]">PV</div>
          <div className="text-[34px] sm:text-[42px] font-black tracking-[-0.02em] text-[var(--ink)] mt-1" data-testid="pv-stat-total-value">
            {fmt(stats?.pv)}
          </div>
        </div>
        <div className="rounded-xl border border-[var(--line)] bg-white p-4 text-center" data-testid="pv-stat-today">
          <div className="text-[11px] uppercase tracking-[0.22em] font-black text-[var(--muted)]">PVT</div>
          <div className="text-[34px] sm:text-[42px] font-black tracking-[-0.02em] text-[var(--ink)] mt-1" data-testid="pv-stat-today-value">
            {fmt(stats?.pvt)}
          </div>
        </div>
      </div>
    </section>
  );
}
